export default __webpack_public_path__ + "static/media/net.4889519c.png";